import React from "react";

import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";

/* The navy "3 · <method>" bar the design puts above the open method. */
export const FinancialMethodBar = ({ method, Icon, onChange, className = "" }) => (
  <div
    className={cn(
      /* `justify-end` matters on the WRAPPED row: the button is the last item, so at full width `flex-1` on the text already pushes it to the edge — but once the... */
      "flex flex-wrap items-center justify-end gap-3 rounded-[12px]",
      "bg-[var(--navy)] px-4 py-3.5",
      className
    )}
  >
    <span
      aria-hidden="true"
      className={cn(
        "flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px]",
        "bg-white/10 text-[var(--orange)]"
      )}
    >
      {Icon ? <Icon size={16} /> : null}
    </span>

    <div className="min-w-0 flex-1">
      <p className="m-0 text-[14px] font-bold text-white font-sans">
        3 · {method.barTitle}
      </p>
      <p className="m-0 mt-0.5 text-[12.5px] text-white/70 font-sans">
        {method.barSubtitle}
      </p>
    </div>

    <Button variant="onDark" size="sm" className="ml-auto shrink-0" onClick={onChange}>
      Change method
    </Button>
  </div>
);

export default FinancialMethodBar;
